import type { GambleStep } from "@slot/game-shell";

export const step03Win: GambleStep = {
  outcome: "win",
  multiplier: "2",
  serverChosenValue: "red",
  terminatesFlow: true,
  // base post-bet balance 100000 + newWin 1600
  balanceAmountMinor: "101600",
};
